import { preactDynamicComponent } from 'common/module/preact/dynamic/component';

import { MyAccountEmptyListTemplate } from './template';

export const MyAccountEmptyListComponent = preactDynamicComponent(MyAccountEmptyListTemplate);
